import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css"; // Ensure this path is correct
import "../css/index.css";  // Ensure this path is correct
import "../css/font-awesome.min.css";
import { Link } from "react-router-dom";


const WhyChooseUs = () => {
  return (
    <section id="choose">
      <div className="container-fluid p-0">
        <div className="row choose_1 m-0">
          <div className="col-md-6 p-0">
            <div className="choose_1l">
              <div className="grid clearfix">
                <figure className="effect-jazz mb-0">
                  <a href="/shop">
                    <img src="img/White and Green Simple  Professional Business Project Presentation-1.png" className="w-100" alt="abc" />
                  </a>
                </figure>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="choose_1r">
              <h4 className="col_blue">Why Choose Us</h4>
              <h2>
                We Are Best <br /> Electrical Store in <br /> Town
              </h2>
              <p>
                Irfan Electricals provides quality electrical products and reliable services.
              </p>
              <div className="choose_1ri row">
                <div className="col-md-5">
                  <div className="choose_1ril bg_blue p-4 rounded_5">
                    <span className="col_yell fs-1 lh-1">
                      <i className="fa fa-thumbs-o-up"></i>
                    </span>
                    <h4 className="mb-0 text-white mt-2">
                      We Provide The Best Guarantee For You Loyal Customers
                    </h4>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="choose_1rir">
                    <h6>
                      Best Price <span className="float-end">88%</span>
                    </h6>
                    <div className="progress-bar mt-2">
                      <div className="progress" style={{ width: '88%' }}></div>
                    </div>
                    <h6 className="mt-4">
                      Trusted Company <span className="float-end">86%</span>
                    </h6>
                    <div className="progress-bar mt-2">
                      <div className="progress" style={{ width: '86%' }}></div>
                    </div>
                    <p className="mt-4">
                      <i className="fa fa-check col_blue me-1"></i> Many Brands
                    </p>
                    <p className="mt-3">
                      <i className="fa fa-check col_blue me-1"></i> Best Quality Product
                    </p>
                    <p className="mt-3 mb-0">
                      <i className="fa fa-check col_blue me-1"></i> Commitment to Customers
                    </p>
                  </div>
                </div>
              </div>

              <h6 className="mb-0 mt-4 text-uppercase">
                <Link className="button" to="/shop">Shop Now</Link>
            </h6>
          </div>
        </div>
      </div>
    </div>
    </section >
  );
};

export default WhyChooseUs;
